"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n  padding: 5px;\n  padding-left: 14px;\n  width: fit-content;\n  border: 1px solid ", ";\n  border-radius: 20px;\n\n  p {\n    font-family: ", ";\n    color: ", ";\n    font-style: normal;\n    font-weight: normal;\n    font-size: 18px;\n    line-height: 25px;\n\n    & + * {\n      margin-left: 5px;\n    }\n  }\n\n  button {\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    height: 20px;\n  }\n\n  & + * {\n    margin-left: 5px;\n  }\n"])), _variables.GlobalColors.s2, _variables.FontFamily.AvenirNext, _variables.GlobalColors.s3);

exports.Container = Container;